"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/JMFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_118)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_118`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "#6DA544"
				}),
				/* @__PURE__ */ n("path", {
					d: "M9.15088 12L-6 22.0772V1.88068L9.15088 12ZM30 1.88068V22.0772L14.7789 12L30 1.88068Z",
					fill: "black"
				}),
				/* @__PURE__ */ n("path", {
					d: "M30 1.8807L14.7789 12L30 22.0772V24H27.1158L11.9649 13.8526L-3.18597 24H-6V22.0772L9.15088 12L-6 1.8807V0H-3.18597L11.9649 10.0982L27.1158 0H30V1.8807Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M30 1.8807L14.7789 12L30 22.0772V24H27.1158L11.9649 13.8526L-3.18597 24H-6V22.0772L9.15088 12L-6 1.8807V0H-3.18597L11.9649 10.0982L27.1158 0H30V1.8807Z",
					fill: "#FFDA44"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_118`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as JMFlag };
